import axios from "axios";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import firebase from "./firebase";
import request from "../infra/request";

const buildEmptyAutoSmsTemplateSet = (name) => {
  const setId = uuidv4();
  const templateDefs = [
    { name: "At Home Initial SMS", order: 1, type: "AT_HOME" },
    { name: "At GP Initial SMS", order: 1, type: "AT_GP" },
    { name: "At Home Reminder SMS Two", order: 3, type: "AT_HOME" },
    { name: "At Home Last SMS", order: 4, type: "AT_HOME" },
    { name: "At Home Reminder SMS One", order: 2, type: "AT_HOME" },
    { name: "At GP Reminder SMS Two", order: 3, type: "AT_GP" },
    { name: "At GP Last SMS", order: 4, type: "AT_GP" },
    { name: "At GP Reminder SMS One", order: 2, type: "AT_GP" },
  ];
  const templates = templateDefs.map((def) => {
    const id = uuidv4();
    return { content: "", id, ...def };
  });
  return {
    id: setId,
    name,
    type: "appointment_auto_sms",
    templates,
  };
};

const _templateSetToRtdbPayload = (templateSet) => {
  const copiedTemplateSet = { ...templateSet };
  copiedTemplateSet.templates = (templateSet.templates || []).reduce((result, template) => {
    result[`${template.id}`] = { ...template };
    return result;
  }, {});
  return copiedTemplateSet;
};

const _transformTemplateSetsResult = (templateSetsResult) => {
  if (_.isNull(templateSetsResult)) {
    return [];
  }
  return Object.keys(templateSetsResult).map((id) => ({
    ...templateSetsResult[id],
    templates: _.isNull(templateSetsResult[id].templates)
      ? []
      : Object.keys(templateSetsResult[id].templates).map((templateId) => ({
          ...templateSetsResult[id].templates[templateId],
        })),
  }));
};

export const getAllSMSTemplates = async (query) => {
  let result = [];
  const type = _.get(query, "type");
  try {
    const response = await request.get("/admin/sms-template-sets");
    const templateSets = response.data.templateSets;
    if (_.isNull(templateSets)) {
      return { result, error: null };
    }
    result = _transformTemplateSetsResult(templateSets);
    result = _.isNil(type) ? result : result.filter((set) => set.type === type);
    return {
      result,
      error: false,
    };
  } catch (err) {
    console.log(err);
    return { result, error: true };
  }
};

export const updateSMSTemplate = async (templateSet) => {
  try {
    await request.put(`/admin/sms-template-sets/${encodeURIComponent(templateSet.id)}`, {
      templateSet: _templateSetToRtdbPayload(templateSet),
    });
    return { result: "", error: false };
  } catch (err) {
    console.log(err);
    return { result: "", error: true };
  }
};

export const createAutoSmsTemplateSet = async (name) => {
  const templateSet = buildEmptyAutoSmsTemplateSet(name);
  try {
    await request.post("/admin/sms-template-sets", { templateSet: _templateSetToRtdbPayload(templateSet) });
    return { result: templateSet, error: false };
  } catch (err) {
    console.log(err);
    return { result: null, error: true };
  }
};

export const renameAutoSmsTemplateSet = async ({ id, name }) => {
  try {
    await request.put(`/admin/sms-template-sets/${encodeURIComponent(id)}/name`, { name });
    return { error: false };
  } catch (err) {
    console.log(err);
    return { error: true };
  }
};

export const getManualSmsTemplates = async () => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/templates/manual-sms`, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    });
    return data;
  } catch (error) {
    return null;
  }
};

export const createManualSmsTemplate = async ({ name, content }) => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.post(
      `${process.env.REACT_APP_API_HOST}/templates/manual-sms`,
      { name, content },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    );
    return data;
  } catch (error) {
    return null;
  }
};

export const updateManualSmsTemplate = async ({ id, name, content }) => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.put(
      `${process.env.REACT_APP_API_HOST}/templates/manual-sms/${id}`,
      { name, content },
      {
        headers: { Authorization: `Bearer ${userIdToken}` },
      }
    );
    return data;
  } catch (error) {
    return null;
  }
};

export const deleteManualSmsTemplate = async ({ id }) => {
  try {
    const userIdToken = await firebase.currentUser().getIdToken();
    const { data } = await axios.delete(`${process.env.REACT_APP_API_HOST}/templates/manual-sms/${id}`, {
      headers: { Authorization: `Bearer ${userIdToken}` },
    });
    return data;
  } catch (error) {
    return null;
  }
};
